var render, staticRenderFns
import script from "./PlaceholderRect.vue?vue&type=script&lang=js&"
export * from "./PlaceholderRect.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderRect.vue?vue&type=style&index=0&id=0cd578fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd578fb",
  null
  
)

export default component.exports